<div class="container-scroller content-wrapper">
  <div class="d-flex col-lg-11 mx-auto central-main mt-2">
    <img class="header-logo cursor-pointer" routerLink="/home" src="assets/svg/logo.svg" alt="header logo">
  </div>
  <div class="container-fluid page-body-wrapper full-page-wrapper">
    <div class="content-wrapper d-flex align-items-center auth px-0">
      <div class="row w-100 mx-0">
        <div class="col-lg-5 mx-auto central-main">
          @if (notVerifiedMessage) {
            <div
              class="min_media alert alert-danger d-flex align-items-start alert-dismissible fade show mb-6 notVerifiedMessage">
              <mat-icon class="me-2 bi flex-shrink-0">cancel</mat-icon>
              <div>{{ 'login_content.not_verified' | translate }}</div>
            </div>
          }
          @if (verifiedMessage) {
            <div
              class="min_media alert alert-success d-flex align-items-center alert-dismissible fade show mb-6 successMessage">
              <img src="assets/svg/successIcon.svg" alt="Success Icon" class="me-2">
              <div>{{ 'login_content.successfully_verified' | translate }}</div>
            </div>
          }
          <div class="auth-form-light pt-custom text-left py-5 px-4 px-sm-5 position-relative">
            <app-search></app-search>
            <h2 class="login-title"> {{ 'login_content.welcome' | translate }}</h2>
            <form [formGroup]="form" (ngSubmit)="login()"
                  (keydown.enter)="$event.preventDefault(); loginButton.focus(); loginButton.click()" method="post"
                  class="pt-3">
              <div class="form-group">
                <input id="email" type="text" name="email" formControlName="email"
                       placeholder="{{'login_content.email' | translate}}"
                       class="form-control form-control-lg"
                       [ngClass]="{'has-error': loginFormControl['email'].invalid && loginFormControl['email'].touched}"
                       (click)="resetErrorMessage()"
                       autocomplete="off"/>
                @if (loginFormControl['email'].invalid && loginFormControl['email'].touched) {
                  <div class="validation">
                    @if (loginFormControl['email'].errors?.['required']) {
                      <small>{{ 'login_content.enter_email' | translate }}</small>
                    }
                    @if (loginFormControl['email'].errors?.['pattern']) {
                      <small>{{ 'login_content.valid_email' | translate }}</small>
                    }
                  </div>
                }
              </div>
              <div class="form-group">
                <div class="mr-2 flex-fill me-4 password-max-width">
                  <div class="password-input-container">
                    <input formControlName="password" [type]="showPassword ? 'text' : 'password'" #passwordInput
                           placeholder="{{'login_content.password' | translate}}"
                           class="form-control form-control-lg"
                           [ngClass]="{'has-error': loginFormControl['password'].invalid && loginFormControl['password'].touched}"
                           (click)="resetErrorMessage()"
                           autocomplete="off"/>
                    <span class="eye-icon">
                           <i class="bi" [ngClass]="{'bi-eye': showPassword, 'bi-eye-slash': !showPassword}"
                              (click)="togglePasswordVisibility()"></i>
                    </span>
                  </div>
                  @if (loginFormControl['password'].invalid && loginFormControl['password'].touched) {
                    <div class="validation">
                      @if (loginFormControl['password'].errors?.['required']) {
                        <small>{{ 'login_content.enter_password' | translate }}</small>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="my-2 d-flex justify-content-between align-items-center">
                <button (click)="navigateTo('/forgot-password')" class="btn-as-link">
                  {{ 'login_content.forgot_password' | translate }}
                </button>
              </div>
              <div class="mt-4">
                <button class="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                        [disabled]="form.invalid"
                        type="submit"
                        #loginButton>
                  {{ 'login_content.login' | translate }}
                </button>
                @if (loginError) {
                  <div class="validation mt-2 text-center fs-14">{{ 'login_content.incorrect_email' | translate }}</div>
                }
                @if (unregisteredMail) {
                  <div class="validation mt-2 text-center fs-14">{{ 'login_content.not_found' | translate }}</div>
                }
              </div>
            </form>
            <div class="text-center mt-4 font-weight-light login-question">
              {{ 'login_content.dont_have_account' | translate }}<button (click)="navigateTo('/sign-up')" class="btn-as-link ml-3px">
              {{ 'login_content.sign_up' | translate }}
            </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
